import type { PayStub } from "./types";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export const getToken = (): string =>
  localStorage.getItem("access_token") || localStorage.getItem("token") || "";

export const authHeaders = (): Record<string, string> => ({
  Authorization: "Bearer " + getToken(),
  "Content-Type": "application/json",
});

export const formatCurrency = (
  value: number | string | null | undefined,
  currency?: string
): string => {
  if (value === null || value === undefined) return "$0.00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "$0.00";
  try {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: currency || "CAD",
    }).format(num);
  } catch (e) {
    return num.toFixed(2);
  }
};

export const formatHours = (h: number | string | null | undefined): string => {
  if (h === null || h === undefined || h === "") return "";
  const num = typeof h === "string" ? parseFloat(h) : h;
  if (isNaN(num) || num === 0) return "";
  return num.toFixed(2);
};

export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (e) {
    return dateStr;
  }
};

export const pick = <T = unknown>(
  obj: Record<string, unknown> | null | undefined,
  ...keys: string[]
): T | null => {
  if (!obj) return null;
  for (const k of keys) {
    const v = obj[k];
    if (v !== undefined && v !== null && v !== "") return v as T;
  }
  return null;
};

export const getStubName = (stub: PayStub): string => {
  const direct =
    pick<string>(stub as Record<string, unknown>, "employee_name", "name", "full_name") ||
    [
      pick<string>(stub as Record<string, unknown>, "first_name"),
      pick<string>(stub as Record<string, unknown>, "last_name"),
    ]
      .filter(Boolean)
      .join(" ");
  if (direct) return direct;

  if (stub.employee) {
    const emp = stub.employee as Record<string, unknown>;
    const nested =
      pick<string>(emp, "name", "full_name") ||
      [pick<string>(emp, "first_name"), pick<string>(emp, "last_name")]
        .filter(Boolean)
        .join(" ");
    if (nested) return nested;
  }

  return "Unnamed";
};